import { AnimatePresence, motion } from 'framer-motion';
import { Code, ExternalLink, Github, Layers, X } from 'lucide-react';

const ProjectModal = ({ isModalOpen, selectedProject, handleCloseModal }) => {
    return (
        <AnimatePresence>
            {isModalOpen && selectedProject && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={handleCloseModal}
                        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                    />

                    <motion.div
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        className="relative w-full max-w-3xl max-h-[90vh] overflow-y-auto glass bg-white dark:bg-dark-card rounded-2xl shadow-2xl border border-white/20 dark:border-white/10"
                    >
                        <button
                            onClick={handleCloseModal}
                            className="absolute top-4 right-4 p-2 rounded-full bg-gray-100 dark:bg-white/10 text-gray-500 dark:text-gray-400 hover:bg-red-500 hover:text-white transition-colors z-10"
                        >
                            <X size={20} />
                        </button>

                        <div className="p-8">
                            <div className="flex items-center gap-3 mb-2 text-primary-purple">
                                <Code size={20} />
                                <span className="font-fira-code text-sm">Project Details</span>
                            </div>

                            <h2 className="text-3xl font-bold mb-6 text-gray-800 dark:text-white">
                                {selectedProject.title}
                            </h2>

                            <div className="flex flex-wrap gap-4 mb-8">
                                {selectedProject.liveLink && (
                                    <a
                                        href={selectedProject.liveLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-primary text-sm py-2 px-5"
                                    >
                                        <ExternalLink size={18} className="mr-2" />
                                        Live Demo
                                    </a>
                                )}
                                <a
                                    href={selectedProject.githubLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-outline text-sm py-2 px-5"
                                >
                                    <Github size={18} className="mr-2" />
                                    Source Code
                                </a>
                            </div>

                            <div className="grid md:grid-cols-3 gap-8">
                                <div className="md:col-span-2 space-y-6">
                                    <div>
                                        <h3 className="text-lg font-semibold mb-3 text-gray-800 dark:text-white flex items-center gap-2">
                                            <Layers size={20} className="text-secondary-blue" />
                                            Description
                                        </h3>
                                        <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                                            {selectedProject.details || selectedProject.description}
                                        </p>
                                    </div>
                                </div>

                                <div className="space-y-6">
                                    <div className="glass-panel p-5 bg-gray-50 dark:bg-white/5">
                                        <h3 className="text-sm font-semibold mb-4 text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                            Tech Stack
                                        </h3>
                                        <div className="flex flex-wrap gap-2">
                                            {selectedProject.techStack.map((tech, i) => (
                                                <span
                                                    key={i}
                                                    className="text-xs px-3 py-1.5 rounded-md bg-primary-purple/10 text-primary-purple font-medium border border-primary-purple/20"
                                                >
                                                    {tech}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default ProjectModal;
